import * as React from "react";
//Utilities and hooks
import addCommas from "helpers/index";
import { min, max } from "lodash";
import { inject, observer } from "mobx-react";
import UserStore from "state/user";
import { Line } from "react-chartjs-2";
import { Chart, ChartOptions } from "chart.js";
import moment from "moment-jalaali";
// Styles
import styles from "./index.module.scss";

moment.loadPersian();
Chart.defaults.global.defaultFontFamily = "IRANSans";

interface IProps {
	user?: UserStore | any;
}

const GoldGraph: React.FC<IProps> = (props: IProps) => {
	const data: number[] = [];
	const selling: number[] = [];
	const labels: string[] = [];

	// eslint-disable-next-line array-callback-return
	props.user.getAssetsPrices.map((price: Stock.PriceChart) => {
		data.push(price.b);
		selling.push(price.s);
		labels.push(moment(price.d * 1000).format("jDD jMMMM"));
	});

	// reverse array after push diff values
	// reverse(data);
	// reverse(selling);
	// reverse(labels);
	// const dataLength = data.length;
	// const sellingLength = selling.length;

	// if (dataLength > sellingLength) {
	// 	for (let index = 0; index < dataLength - sellingLength; index++) {
	// 		selling.push(selling[sellingLength - 1]);
	// 	}
	// } else {
	// 	for (let index = 0; index < sellingLength - dataLength; index++) {
	// 		data.push(data[dataLength - 1]);
	// 	}
	// }

	const mainChart = {
		labels,
		datasets: [
			{
				label: "قیمت خرید طلا",
				backgroundColor: "transparent",
				borderColor: "#28a745",
				pointHoverBackgroundColor: "#ffffff",
				borderWidth: 2,
				data,
			},
			{
				label: "قیمت فروش طلا",
				backgroundColor: "transparent",
				borderColor: "#01a4b5",
				pointHoverBackgroundColor: "#ffffff",
				borderWidth: 2,
				data: selling,
			},
		],
	};

	const __max = Number(max(data));
	const __min = Number(min(selling));
	const mainChartOpts: ChartOptions = {
		maintainAspectRatio: false,
		legend: {
			display: true,
			position: "bottom",
		},
		tooltips: {
			mode: "label",
			callbacks: {
				label: function(tooltipItem, data) {
					return addCommas(tooltipItem.yLabel) + " ریال";
				},
			},
		},
		scales: {
			xAxes: [
				{
					gridLines: {
						drawOnChartArea: true,
					},
				},
			],
			yAxes: [
				{
					ticks: {
						beginAtZero: true,
						stepSize: 500000,
						max: Math.round(__max + (__max - __min) / 10), // +100,000 IRR
						min: Math.round(__min - (__max - __min) / 10),
						callback: function(value, index, values) {
							return (addCommas(value) || 0) + " ریال";
						},
					},
				},
			],
		},
		elements: {
			point: {
				radius: 0,
				hitRadius: 10,
				hoverRadius: 4,
				hoverBorderWidth: 3,
			},
		},
	};

	return (
		<div className={styles["graph"]}>
			<div className={styles["graph-header"]}>
				<div className={styles["graph-header__sell"]}>
					<span>قیمت فروش طلا:</span>
					<span> {addCommas(props.user.goldSellPrice)}</span>
					<span> </span>
					<span>ریال</span>
				</div>
				<div className={styles["graph-header__buy"]}>
					<span>قیمت خرید طلا:</span>
					<span>{addCommas(props.user.goldBuyPrice)}</span>
					<span>ریال</span>
				</div>
			</div>
			<div className={styles["chart"]}>
				<Line data={mainChart} options={mainChartOpts} height={200} />
			</div>
		</div>
	);
};

export default inject("user")(observer(GoldGraph));
